@if (isPiPEnable()) {
  <span>
    @if (windowPopOut()) {
      <button class="close-popout-button" matTooltip="Close pop out" (click)="stopPictureInPicture()">
        <mat-icon>chevron_left</mat-icon>
        <mat-icon>picture_in_picture</mat-icon>
      </button>
    }
    @if (!windowPopOut()) {
      <span class="menu-wrapper">
        <button
          [matMenuTriggerFor]="menu"
          #t="matMenuTrigger"
          [ngClass]="{ 'menu-open': t.menuOpen, 'popout-menu': true }"
        >
          <mat-icon class="mat-icon-style"> more_vert </mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" class="menu-styled">
          <button mat-menu-item (click)="startPictureInPicture()">
            <mat-icon class="mat-icon-style">picture_in_picture</mat-icon>
            <span>Open pop-out</span>
          </button>
        </mat-menu>
      </span>
    }
  </span>
}
